var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddReceiverIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 8.5,
    r: 5,
    fill: "#0E1012"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 10.5v6M22 13.5h-6",
    stroke: "#0E1012",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.142 20.883c.462-.105.739-.585.534-1.012-.552-1.15-1.459-2.162-2.634-2.924C13.595 16.009 11.823 15.5 10 15.5s-3.595.509-5.042 1.447c-1.175.762-2.082 1.773-2.634 2.924-.205.427.072.907.534 1.012a32.333 32.333 0 0 0 14.284 0Z",
    fill: "#0E1012"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddReceiverIcon);
export default __webpack_public_path__ + "static/media/add-receiver-icon.05c3f317a0075aa95741277e65b34bb0.svg";
export { ForwardRef as ReactComponent };